<template>
    <div class="evaluation-box-content person-box">
        <!-- <el-row class="zy-img">
            <img src="../../assets/images/banner_zncp.png" alt="查专业" class="zy-img">
            </el-row> -->
        <!-- <Breadcrumb></Breadcrumb> -->
        <div class="evaluation-bg">
            <el-breadcrumb
                separator-class="el-icon-arrow-right"
                class="breadcrumb-box"
            >
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>学业目标测评</el-breadcrumb-item>
            </el-breadcrumb>
            <el-row class="evaluation-card evaluation-card-box1">
                <el-col :span="24">
                <h3>学业目标测评(Goal)</h3>
                <h6>
                    <span>
                    <img src="../../assets/images/people.png" alt="完成人数" />
                    {{ experienceList.test_use_count }}人已完成
                    </span>
                    <!-- <span style="margin-left: 20px">
                    <img src="../../assets/images/question.png" alt="完成人数" />
                    {{ experienceList.test_count }}道题
                    </span> -->
                </h6>
                <button @click="StartTest" :disabled="experienceList.user_count == 0 ? true : false">立即测试</button>
                <button @click="gotoPerson" class="evaluation-card-btn">测试记录</button>
                    <h6 style="margin-top: 16px;">
                        本月还剩{{ experienceList.user_count }}次测试机会
                    </h6>
                </el-col>
            </el-row>
        </div>
        <el-row class="zy-school">
            <div class="evaluation-infor">
                <span class="evluation-infor-title-bg2"></span>
                <span class="evluation-infor-title-bg1"></span>
                <h3>测评介绍</h3>
            </div>
            <el-row class="goal-view" :gutter="16">
                <el-col v-for="(item, index) in toolsList" :key="index" :span="8">
                    <div class="flex">
                        <img :src="item.src">
                        <div>
                            <h4>{{ item.name }}</h4>
                            <p>{{ item.desc }}</p>
                        </div>
                    </div>
                </el-col>
            </el-row>
            <p>
                本测评旨在通过设定清晰目标激励学生勇往直前。依托近5年的亿级高考数据，根据您的模拟考成绩，我们为您提供精准定位，模拟未来高考志愿填报，生成5分一段的个性化院校推荐。同时，综合考虑院校类型、地域分布、学生性别及热门专业，为您量身定制合适的升学目标。每答对一道题，都能让您清晰看到通往理想大学的每一步。
            </p>
            <img
                src="../../assets/images/goal-img1.png"
                alt="学业目标测评"
                class="evluation-xingqu"
            />
        </el-row>
        <el-row class="evaluation-detail-drawer" v-show="openTest">
            <el-row class="drawer-box">
                <el-row class="drawer-box-top">
                    <el-col :span="12" class="drawer-title">学业目标测评(Goal)</el-col>
                    <el-col :span="12">
                        <button @click="hiddenQuestion">退出</button>
                    </el-col>
                </el-row>
                <el-steps v-if="activeStep<3" :active="activeStep">
                    <el-step title="您的选科"></el-step>
                    <el-step title="成绩位置"></el-step>
                    <el-step title="意向专业"></el-step>
                </el-steps>
                <template v-if="activeStep==0">
                    <h4>请选择您的选科<span>（如您还未进行选科，可根据你的兴趣擅长选择）</span></h4>
                    <el-form :model="form1" ref="form1" :label-width="formLabelWidth1" :rules="rulesInfor1">
                        <el-form-item label="我的性别:" prop="gender" class="item-diff">
                            <el-button v-for="(item,index) in sexList" :class="index==activeIndex1?'active-batch':''" :key="index" @click="changeIndex1(index,item)">{{item.value}}</el-button>
                        </el-form-item>
                        <el-form-item label="我的选科:" prop="subject_id" class="item-diff item-check">
                            <el-checkbox-group :max="3" v-model="form1.subject_id">
                                <el-checkbox :label="4" :disabled="form1.subject_id.includes(8)?true: false">物理</el-checkbox>
                                <el-checkbox :label="8" :disabled="form1.subject_id.includes(4)?true: false">历史</el-checkbox>
                                <el-checkbox v-for="(item, index) in subjectList2" :key="index" :label="item.key">
                                    {{ item.value }}
                                </el-checkbox>
                            </el-checkbox-group>
                            <!-- <el-button v-for="(item,index) in subjectList" :class="index==formInforActiveIndex2?'active-batch':''" :key="index" disabled>{{item.dic_value}}</el-button> -->
                        </el-form-item>
                    </el-form>
                </template>
                <template v-else-if="activeStep==1">
                    <h4>请确定您的成绩位置<span>（请输入您最近的模拟考试的成绩，并且可以询问老师得到本次考题对比高考考题的难度）</span></h4>
                    <el-form :model="form2" ref="form2" :label-width="formLabelWidth1" :rules="rulesInfor2">
                        <el-form-item label="我的分数:" prop="score" class="item-input">
                            <el-input v-model.number="form2.score" autocomplete="off" placeholder="请输入分数">
                                <template slot="append">分</template>
                            </el-input>
                            <span>请输入语文、数学、外语、{{form1.subject.join('、')}} 此六科的总分数</span>
                        </el-form-item>
                        <el-form-item label="批次:" prop="local_batch_id" class="item-diff">
                            <el-button v-for="(item,index) in batchList" :class="index==activeIndex2?'active-batch':''" :key="index" @click="changeIndex2(index, item.local_batch_id)">{{item.name}}</el-button>
                        </el-form-item>
                        <!-- <el-form-item label="试卷难度:" prop="difficulty" class="item-diff">
                            <el-button v-for="(item,index) in easyList" :class="index==activeIndex3?'active-batch':''" :key="index"  @click="changeIndex3(index, item)">{{item.value}}</el-button>
                        </el-form-item> -->
                    </el-form>
                </template>
                <template v-else-if="activeStep==2">
                    <h4>请选择五个热点专业<span>（您可以在系统根据您的选科及性别为您推荐的专业中选择或通过添加选择五个心仪的专业）</span></h4>
                    <div class="major-view">
                        <div class="flex grid1 major-top">
                            <div>已选专业(<span>{{selectMajor.length}}</span>/5)</div>
                            <button @click="showIntentionMajor"><img src="../../assets/images/add.png"/>添加心仪专业</button>
                        </div>
                        <div v-if="selectMajor.length > 0" class="add-major">
                            <span v-for="(item, index) in selectMajor" :key="index">{{item.special_name}}<img src="../../assets/images/remove_white.png" @click="removeMajor(index)"/></span>
                        </div>
                        <p v-else>暂无选中专业，请添加心仪专业或从推荐专业中选择</p>
                    </div>
                    <div v-if="majorList.length > 0" class="major-list">
                        <div class="major-text">推荐专业</div>
                        <el-scrollbar style="height: 120px;overflow-x: hidden">
                            <span v-for="(item, index) in majorList" :key="index" @click="activeMajor(item)" :class="item.flag?'active-batch':''">{{item.special_name}}</span>
                        </el-scrollbar>
                    </div>
                </template>
                <div v-else-if="activeStep==3" class="success">
                   <img src="../../assets/images/pay_success.png"/>
                   <h3>测评完成</h3>
                   <p>感谢您的参与，点击下方按钮查看您的专属报告吧！</p>
                   <button @click="linkEvaDetailHandler">查看报告</button>
                </div>
                <div class="btn-list">
                    <button class="drawer-btn next-btn" v-if="activeStep==2" @click="submitBtn">提交测评</button>
                    <button class="drawer-btn next-btn" v-else-if="activeStep<2" @click="showNext">下一步</button>
                    <button class="next-btn" v-if="activeStep > 0 && activeStep < 3" @click="showPrev">上一步</button>
                </div>
            </el-row>
        </el-row>
        <IntentionMajor v-if="isIntentionMajor" @update="addMajor" :majorList="selectMajor" :level="majorLevel"></IntentionMajor>
    </div>
</template>

<script>
import { getEvaluationTimes } from "@/api/home";
import { getHistoryRecordDetail } from "@/api/user";
import { mapState } from "vuex";
import { Message } from 'element-ui';
import {
    getMajor,
    addTest
} from "@/api/evaluation";
import IntentionMajor from '@/components/IntentionMajor'
export default {
    components: { IntentionMajor },
    data() {
        return {
            // typeIndex:0,
            experienceList: [],
            openTest: false,
            toolsList: [
                {src: require('../../assets/images/goal-icon1.png'),name: '生成5分一段冲刺目标',desc: '为您生成5分一段的高校冲刺目标，让您每做对一道选择题就能看到一个新的美好未来',path: ''},
                {src: require('../../assets/images/goal-icon2.png'),name: '模拟高考志愿',desc: '基于近5年的近亿高考大数据，根据你的模拟考试成绩为您进行精准定位，帮助您提前模拟未来高考志愿的位置信息',path: ''},
                {src: require('../../assets/images/goal-icon3.png'),name: '推荐省内省外院校目标',desc: '结合院校类别，为您分别推荐省内省外院校目标，同时结合学生性别及热门专业，为您推荐适合的院校推荐目标',path: ''},
            ],
            activeStep: 0,
            has_code: 0,
            formLabelWidth1: '80px',
            reportInfo: {},
            form1: {
                gender: '',
                subject_id: [],
                subject: []
            },
            form2: {
                score: '',
                local_batch_id: '',
                // difficulty: 1
            },
            batchList: JSON.parse(sessionStorage.getItem('batchList')),
            activeIndex1: -1,
            activeIndex2: 0,
            activeIndex3: 0,
            sexList: [
                {key: 1, value: '男生'},
                {key: 2, value: '女生'}
            ],
            subjectList: [
                {key: 4, value: '物理'},
                {key: 8, value: '历史'},
                {key: 5, value: '化学'},
                {key: 6, value: '生物'},
                {key: 7, value: '政治'},
                {key: 9, value: '地理'}
            ],
            subjectList2: [
                {key: 5, value: '化学'},
                {key: 6, value: '生物'},
                {key: 7, value: '政治'},
                {key: 9, value: '地理'}
            ],
            easyList: [
                {key: 1, value: '简单'},
                {key: 2, value: '正常'},
                {key: 3, value: '较难'},
            ],
            majorList: [],
            selectMajor: [],
            majorLevel: 1,
            rulesInfor1: {
                gender: [
                    {message: '请选择性别', trigger: 'blur', required: true}
                ],
                subject_id: [
                    {message: '请选择科目', trigger: 'blur', required: true}, {
                      validator: (rule, value, callback) => {
                        if (value.length !== 3) {
                          callback(new Error('请选择三个科目'));
                        } else {
                          callback();
                        }
                      },
                      trigger: 'blur'
                    }
                ],
            },
            rulesInfor2: {
                score: [
                    {message: '请输入分数', trigger: 'blur', required: true}
                ]
            },
        };
    },
    computed: {
        ...mapState({
            token: (state) => state.user.token,
            isShowVip: state => state.user.isShowVip,
            isVipStr: state => state.user.isVipStr,
            isIntentionMajor: state => state.user.isIntentionMajor,
            function_code: state => state.user.function_code
        }),
    },
    watch: {
        token (newVal) {
            if(newVal != '') {
                this.getEvaluationTimes()
            }
        },
        function_code() {
            const tmp = this.function_code.filter(item => { return item.function_code === 'F00008'})
            if(tmp.length > 0) {
                this.has_code = tmp[0].has_code
            }
        }
    },
    mounted() {
        if(!this.$store.state.user.token) {
            this.$store.commit('user/LOGINSTATUS', true)
            return
        }
        const tmp = this.function_code.filter(item => { return item.function_code === 'F00008'})
        if(tmp.length > 0) {
            this.has_code = tmp[0].has_code
        }
        this.getEvaluationTimes()
    },
    methods: {
        getEvaluationTimes() {
            getEvaluationTimes().then((res) => {
                let experienceList = []
                res.data.map((item) => {
                 experienceList[item.test_id - 1] = item;
                })
                this.experienceList = {...experienceList[2]}
            });
        },
        hiddenQuestion() {
            this.openTest = false
        },
        StartTest() {
            if(this.has_code == 0) {
                this.$message({
                    message: '您的账户暂未开通此功能',
                    type: 'warning'
                })
                return
            }
            this.openTest = true;
            this.activeStep = 0;
            Object.assign(this.$data.form1, this.$options.data().form1)
            Object.assign(this.$data.form2, this.$options.data().form2)
            this.activeIndex1 = -1;
            this.activeIndex2 = 0;
            this.activeIndex3 = 0;
            this.selectMajor = [];
            this.majorList = [];
            this.form2.local_batch_id = this.batchList[0].local_batch_id
            // this.form2.difficulty = '1'
        },
        changeIndex1(index, item) {
            this.activeIndex1 = index;
            this.form1.gender = item.key;
        },
        changeIndex2(index, local_batch_id) {
			this.activeIndex2 = index;
			this.form2.local_batch_id = local_batch_id
		},
        // changeIndex3(index, item) {
		// 	this.activeIndex3 = index;
		// 	this.form2.difficulty = item.key
		// },
        gotoPerson() {
            this.$router.push({
                path: "/person",
                query: {
                    type: 'test'
                }
            });
        },
        showPrev() {
            if(this.activeStep==1) {
                this.$refs.form2.resetFields()
            }
            this.activeStep--
        },
        showNext() {
            if(this.activeStep == 0) {
                this.form1.subject = []
                this.$refs.form1.validate((valid) => {
                    if (valid) {
                        this.activeStep++
                        this.form1.subject_id.map(item => {
                            const tmp = this.subjectList.filter(val => { return val.key == item })
                            this.form1.subject.push(tmp[0].value)
                        })
                    }
                })
            } else if(this.activeStep == 1) {
                this.$refs.form2.validate((valid) => {
                    if (valid) {
                        this.activeStep++
                        const params = {...this.form1, ...this.form2}
                        params.test_id = this.experienceList.test_id
                        getMajor(params).then((res) => {
                            this.majorList = res.data.map(item => {
                                item.flag = false 
                                return item 
                            })
                        })
                    }
                })
            }
        },
        activeMajor(item) {
            if(!item.flag) {
                 if(this.selectMajor.length > 4) {
                    Message({
                        message: '当前意向专业已选满，请删除意向专业后再添加',
                        type: 'error',
                        duration: 5 * 1000
                    })
                    return
                }
            }
            item.flag = !item.flag
            if(item.flag) {
                this.selectMajor.push(item)
            } else {
                const index_tmp = this.selectMajor.findIndex(val => { return val.special_id == item.special_id })
                if(index_tmp != -1) {
                    this.selectMajor.splice(index_tmp, 1)
                }
            }
        },
        removeMajor(index) {
            this.selectMajor[index].flag = false
            this.selectMajor.splice(index, 1)
        },
        // 心仪专业弹框
        showIntentionMajor() {
            const select_tmp = this.batchList.filter(val => { return val.local_batch_id == this.form2.local_batch_id})
            if(select_tmp[0].name.indexOf('专') != -1) {
                this.majorLevel = 2
            } else {
                this.majorLevel = 1
            }
            this.$store.commit('user/SHOWINTENTIONMAJOR', true)
        },
        // 添加心仪专业
        addMajor(data) {
            this.selectMajor = [...data]
            this.selectMajor.map(item => {
                const index_tmp = this.majorList.filter(val => { return val.special_id == item.special_id })
                if(index_tmp.length > 0) {
                    index_tmp[0].flag = true
                }
            })
        },
        submitBtn() {
            if(this.selectMajor.length < 5) {
                Message({
                    message: '请选择5个专业',
                    type: 'error',
                    duration: 5 * 1000
                })
                return
            }
            const params = {...this.form1, ...this.form2}
            params.test_id = this.experienceList.test_id
            params.spname = this.selectMajor.map(val => {return val.special_name}).join(',')
            addTest(params).then(res => {
                this.activeStep++
                this.reportInfo = res.data
            })
        },
        linkEvaDetailHandler() {
            this.openTest = false
            this.getEvaluationTimes()
            const url = getHistoryRecordDetail(this.reportInfo)
            window.open(url)
        },
    },
};
</script>

<style lang="scss" scoped>
    @import "@/assets/css/variables.scss";
    @font-face {
        font-family: 'zihun443hao';
        src: url('../../assets/fonts/zihun443hao.ttf');
    }
    button {
        outline: none;
    }
    .evaluation-box-content {
        background: #ffffff;
    }
    .evaluation-bg {
        background: url("../../assets/images/goal-bg.png") no-repeat;
        background-position: center;
        background-size: cover;
        height: 438px;
        box-sizing: border-box;
        position: relative;
        .breadcrumb-box {
            margin-top: 0 !important;
        }
    }
    .zy-school {
        @include gwidth;
        margin-top: 68px;
        .evaluation-infor {
            h3 {
                font-size: 26px;
                color: #ffffff;
                font-weight: 600;
                margin: 0 auto;
                position: relative;
                z-index: 99;
                padding: 0 18px;
                line-height: 44px;
            }
            .evluation-infor-title-bg1 {
                transform: skew(-10deg); /*设置倾斜度为-30*/
                -webkit-transform: skew(-10deg);
                -moz-transform: skew(-10deg);
                -o-transform: skew(-10deg);
                -ms-transform: skew(-10deg);
                width: 140px;
                height: 44px;
                background: $common-color;
                border-radius: 8px;
                position: absolute;
                left: 4px;
                top: 0px;
            }
            .evluation-infor-title-bg2 {
                transform: skew(-10deg); /*设置倾斜度为-30*/
                -webkit-transform: skew(-10deg);
                -moz-transform: skew(-10deg);
                -o-transform: skew(-10deg);
                -ms-transform: skew(-10deg);
                width: 140px;
                height: 44px;
                background: #ffd624;
                border-radius: 8px;
                position: absolute;
                top: 4px;
                left: 0px;
            }
        }
        .evluation-infor-js {
            height: 256px;
            background: #f7f9fc;
            border-radius: 8px;
            margin-top: 40px;
            padding: 27px 24px;
            box-sizing: border-box;
            .evluation-infor-js-item:not(:last-child) {
                border-left: 1px dashed $common-color;
                height: 60px;
            }
            .evluation-infor-circle {
                width: 22px;
                height: 22px;
                background: #ffe8de;
                border-radius: 50%;
                position: relative;
                left: -11px;
            span {
                display: inline-block;
                width: 10px;
                height: 10px;
                background: $common-color;
                border-radius: 50%;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }
            }
            .el-col-23 {
                color: #332e33;
                font-weight: 600;
                font-size: 20px;
            }
        }
        p {
            font-size: 20px;
            font-weight: 400;
            color: #332e2c;
            margin-top: 32px;
            line-height: 36px;
        }
        .evluation-xingqu {
            position: relative;
            left: 50%;
            transform: translateX(-50%);
            margin: 24px 0 32px 0;
        }
    }
    .zyb-box {
        background: none;
        border-radius: 0;
        box-shadow: none;
        position: relative;
        top: 0px;
    }
    .evaluation-bg {
        .evaluation-card {
            @include gwidth;
            position: absolute;
            margin-top: 46px;
            left: 50%;
            transform: translateX(-50%);
        }
        .evaluation-img1 {
            width: 200px;
            height: 200px;
            position: relative;
            bottom: 28px;
            right: 28px;
        }
        h3 {
            font-size: 70px;
            color: #ffffff;
            font-weight: 400;
            margin: 0;
            font-family: 'zihun443hao';
            line-height: 101px;
        }
        h6 {
            font-size: 12px;
            color: #ffffff;
            font-weight: 400;
            margin: 0;
            margin-top: 34px;
            img {
                width: 14px;
                height: 14px;
                position: relative;
                top: 3px;
            }
        }
        button {
            border: none;
            font-size: 16px;
            color: #11b09e;
            width: 136px;
            height: 50px;
            background: #ffffff!important;
            border: 1px solid #ffffff!important;
            border-radius: 8px;
            font-size: 18px;
            margin-top: 56px;
            margin-right: 24px;
        }
        .evaluation-card-btn {
            background: rgba(255,255,255,0.20)!important;
            border: 1px solid #ffffff!important;
            border-radius: 8px;
            color: #ffffff;
        }
    }
    .evaluation-detail-drawer {
        background: rgba(0, 0, 0, 0.4);
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 999;
        overflow-y: scroll;
    }
    .drawer-box {
        width: 878px;
        height: 680px;
        background: #ffffff;
        box-shadow: 0px 1px 6px 0px rgba(51, 55, 61, 0.2);
        position: relative;
        left: 50%;
        top: 50%;
        border-radius: 10px;
        transform: translate(-50%, -50%);
        border-radius: 10px;
        padding: 32px 40px;
        position: relative;
        h4 {
            font-size: 20px;
            span {
                font-size: 14px;
                color: #909399;
                font-weight: 300;
            }
        }
        button {
            width: 76px;
            height: 44px;
            background: #ffffff;
            border: 1px solid #c4c7cc;
            border-radius: 8px;
            color: #5e6166;
            font-weight: 400;
            margin-left: 16px;
            font-size: 16px;
        }
        .drawer-btn {
            background: linear-gradient(90deg,#ffa94a, #ff913c);
            color: #ffffff;
            border: 1px solid transparent;
        }
        .next-btn {
             float: right;
             width: 100px;
        }
        .btn-list {
            position: absolute;
            bottom: 0;
            background: #fff;
            padding: 24px 40px;
            width: 100%;
            box-sizing: border-box;
            left: 0;
        }
    }
    .drawer-box-top {
        .drawer-title {
            color: #2c2e33;
            font-weight: 600;
            font-size: 28px;
        }
        .el-col-12:last-child {
            text-align: right;
        }
    }
    .goal-view {
        margin-top: 40px;
        margin-bottom: 8px;
        .el-col-8 {
            > div {
                background: #f5f7fa;
                border-radius: 16px;
                padding: 20px;
            }
            img {
                width: 64px;
                height: 64px;
                margin-right: 16px;
            }
            h4 {
                margin: 0;
                font-size: 20px;
                color: #332e2c;
            }
            p {
                margin: 0;
                font-size: 14px;
                color: #999390;
                line-height: 20px;
                margin-top: 6px;
            }
        }
    }
    .flex {
        display: flex;
        align-items: center;
    }
    ::v-deep {
        .el-scrollbar__wrap {
            overflow-x: hidden;
        }
        .el-steps {
            background: #fff5f1;
            border-radius: 8px;
            padding: 20px 108px;
            margin: 26px 0; 
            .el-step__icon {
                width: 32px;
                height: 32px;
                background: #f1e9e6;
                border-radius: 8px;
                font-size: 16px;
                color: #999390;
                border: none;
            }
            .el-step__line {
                border-top: 1px dashed #ccc6c4;
                background: none;
                top: 16px;
                margin: 0 124px;
                right: 16px;
            }
            .el-step {
                flex-basis: 44%!important;
                display: flex;
                font-size: 16px;
            }
            .el-step:last-of-type.is-flex {
                flex-basis: auto!important;
                min-width: 20%;
            }
            .el-step__main {
                position: absolute;
                left: 45px;
                top: -2px;
            }
            .is-process .el-step__icon, .is-finish .el-step__icon {
                background: #ff6524;
                color: #ffffff;
            }
            .is-process {
                color: #ff6524;
            }
            .is-finish {
                color: #332e2c;
            }
            .el-step__line-inner {
                display: none;
            }
        }
        .el-form {
            .el-form-item__label:before {
                display: none;
            }
            .el-form-item__error {
                margin-left: 0;
            }
            .item-diff .el-form-item__error {
                margin-left: 0;
                top: 76%;
            }
            .item-check .el-form-item__error {
                top: 88%;
            }
            button {
                margin: 0 16px 16px 0!important;
            }
            .item-diff {
                margin-bottom: 4px;
            }
            .item-input {
                .el-input {
                    width: 240px;
                }
                span {
                    font-size: 14px;
                    color: #ff8120;
                    margin-left: 16px;
                    position: relative;
                    top: 8px;
                }
            }
        }
        .el-checkbox {
            width: 106px;
            height: 50px;
            background: #ffffff;
            border: 1px solid #e1e4eb;
            border-radius: 8px;
            font-size: 16px;
            color: #5e6166;
            line-height: 50px;
            text-align: center;
            margin-right: 16px;
            margin-bottom:  16px;
            .el-checkbox__inner {
                width: 20px;
                height: 20px;
                background: #fff!important;
                border-radius: 4px;
                border: 1px solid #e5dcd8!important;
            }
            .el-checkbox__input.is-checked {
                .el-checkbox__inner {
                    background: #ff6524!important;
                    border: 1px solid #ff6524!important;
                }
            }
            &.is-checked {
                background: #fff6f3;
                border: 1px solid #ff6524;
                .el-checkbox__label {
                    color: #ff6524!important;
                }
            }
            .el-checkbox__inner::after {
                top: 3px;
                left: 7px;
                height: 8px;
                width: 4px;
            }
        }
    }
    .major-view {
        border: 1px dashed #ccc6c4;
        border-radius: 8px;
        padding: 16px;
        height: 152px;
        box-sizing: border-box;
        button {
            border: 1px solid #ff6524;
            border-radius: 8px;
            width: 126px;
            height: 32px;
            font-size: 14px;
            color: #ff6524;
        }
        .major-top {
            img {
                position: relative;
                top: 1px;
                margin-right: 4px;
            }
            span {
                color: #ff6524;
            }
        }
        p {
            font-size: 14px;
            color: #ccc6c4;
            text-align: center;
            margin: 0;
            margin-top: 36px;
        }
        .add-major {
            margin-top: 16px;
            span {
                background: #f5f7fa;
                border-radius: 6px;
                margin-right: 8px;
                padding: 6px 16px;
                font-size: 14px;
                color: #ff6524;
                display: inline-block;
                margin-bottom: 8px;
                img {
                    margin-left: 4px;
                    position: relative;
                    top: 2px;
                }
            }
        }
    }
    .major-list {
        margin-top: 16px;
        .major-text {
            color: #66605e;
            font-size: 14px;
            margin-bottom: 16px;
        }
        span {
            border: 1px solid #e1e4eb;
            border-radius: 6px;
            margin-right: 8px;
            padding: 6px 16px;
            font-size: 14px;
            color: #66605e;
            margin-bottom: 8px;
            display: inline-block;
            cursor: pointer;
        }
    }
    .grid1 {
        justify-content: space-between;
    }
    .success {
        text-align: center;
        margin: 140px 0;
        h3 {
            font-size: 28px;
            color: #332e2c;
            line-height: 40px;
            margin: 16px 0 8px 0;
        }
        p {
            font-size: 18px;
            color: #66605e;
            line-height: 25px;
            margin: 0;
        }
        button {
            width: 152px;
            height: 52px;
            border: 1px solid #ff6524;
            border-radius: 8px;
            color: #ff6524;
            margin-top: 32px;
        }
    }
    .active-batch {
        background: #fff6f3!important;
        border: 1px solid #ff6524!important;
        color: #ff6524!important;
    }
</style>